module.exports = __webpack_public_path__ + "static/freshman-6-92dd2c477a8a57c251543b07dea3df83.jpg";